<template>
  <section class="header">
    <strong>{{ $t("helpers.chat.user_support") }}</strong>

    <v-btn icon small @click="closeModal">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "HelpHeaderComponent",

  methods: {
    ...mapActions(["changeHelpModalStatus"]),

    closeModal() {
      this.changeHelpModalStatus(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  strong {
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
